import { render } from "./User.vue?vue&type=template&id=5b2565ea&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=5b2565ea&lang=less&scoped=true"
import "./User.vue?vue&type=style&index=1&id=5b2565ea&lang=less"
import "./User.vue?vue&type=style&index=2&id=5b2565ea&scoped=true&lang=css"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2565ea"]])

export default __exports__